import React, { useState } from 'react';
import { fmtNb, fmtDateFr } from './commun';

// Mini-courbe SVG (cartes indicateurs)
export const Sparkline = ({ valeurs, couleur = '#6d4e36', largeur = 120, hauteur = 28 }) => {
  if (!valeurs?.length) return null;
  const max = Math.max(...valeurs, 1);
  const pas = valeurs.length > 1 ? largeur / (valeurs.length - 1) : 0;
  const pts = valeurs.map((v, i) => `${(i * pas).toFixed(1)},${(hauteur - 2 - (v / max) * (hauteur - 4)).toFixed(1)}`).join(' ');
  return (
    <svg width={largeur} height={hauteur} style={{ display: 'block' }} aria-hidden="true">
      <polyline points={pts} fill="none" stroke={couleur} strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
};

/* Histogramme journalier : une série choisie parmi plusieurs (boutons), survol = valeur du jour.
   series : [{ key, label, couleur, unite }] ; data : [{ date, [key]: valeur }] */
export const HistogrammeJour = ({ data, series, hauteur = 160 }) => {
  const [serie, setSerie] = useState(series[0].key);
  const [survol, setSurvol] = useState(null);
  const s = series.find(x => x.key === serie);
  const max = Math.max(...data.map(d => d[serie] || 0), 1);
  const largeur = 100 / Math.max(data.length, 1);
  return (
    <div>
      <div className="d-flex flex-wrap gap-1 mb-2">
        {series.map(x => (
          <button key={x.key} type="button" onClick={() => setSerie(x.key)}
            className={`btn btn-sm ${serie === x.key ? 'btn-marron' : 'btn-outline-secondary'}`} style={{ fontSize: '0.75rem' }}>
            {x.label}
          </button>
        ))}
        <span className="ms-auto small text-muted align-self-center">
          {survol != null ? `${fmtDateFr(data[survol].date)} : ${fmtNb(data[survol][serie])} ${s.unite || ''}` : 'Survolez une barre'}
        </span>
      </div>
      <svg width="100%" height={hauteur} viewBox={`0 0 100 ${hauteur}`} preserveAspectRatio="none" role="img"
        aria-label={`Évolution journalière — ${s.label}`} onMouseLeave={() => setSurvol(null)}>
        {data.map((d, i) => {
          const h = ((d[serie] || 0) / max) * (hauteur - 14);
          return (
            <rect key={d.date} x={i * largeur + largeur * 0.15} width={largeur * 0.7} y={hauteur - 12 - h} height={Math.max(h, 0.5)}
              fill={s.couleur} opacity={survol === i ? 1 : 0.75} onMouseEnter={() => setSurvol(i)} />
          );
        })}
      </svg>
      <div className="d-flex justify-content-between small text-muted" style={{ fontSize: '0.7rem' }}>
        <span>{data[0] && fmtDateFr(data[0].date).slice(0, 5)}</span>
        <span>{data.length > 1 && fmtDateFr(data[data.length - 1].date).slice(0, 5)}</span>
      </div>
    </div>
  );
};
